import * as React from 'react';
import { PromoFormBlock } from '@design-system/promo-form-block';
import '../../styles/promo.scss';

const PromoForm = ({ data }) => {
  switch (data.layout) {
    default:
      return (
        <div
          className="w-full col-span-12 mx-auto grid grid-cols-12 promo-form container"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          <div className="col-span-12 row-start-1">
            {data.title && <h2>{data.title}</h2>}
          </div>
          <div className="col-span-12 row-start-3 md:row-start-auto md:col-span-6 promo-form-wrapper">
            <p class="promo-form__required-text">* required fields</p>
            <PromoFormBlock
              url="https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms"
              formId={data.form_id}
              submitErrorMessage={data?.submit_error_message}
            />
          </div>
          <div
            className="col-span-12 row-start-2 md:row-start-auto md:col-span-6 promo-form-description"
            dangerouslySetInnerHTML={{
              __html: data.description,
            }}
          />
        </div>
      );
  }
};

export default PromoForm;
